import React from 'react';
import API_CALLS from 'API_CALLS/index';
import TemplatePage from 'global/templates/templatePage/index';

const QUERY = API_CALLS.REFERRALS.QUERIES.allAndCountListFull();
const QUERY_SINGLE = API_CALLS.REFERRALS.QUERIES.singleFull();
const QUERY_COUNT = API_CALLS.REFERRALS.QUERIES.count();
const MUTATION_EDIT = API_CALLS.REFERRALS.MUTATIONS.update();
const MUTATION_ADD = API_CALLS.REFERRALS.MUTATIONS.create();
const QUERY_GET_USERS = API_CALLS.USERS.QUERIES.all(`email`);
const FORM_FIELDS = API_CALLS.REFERRALS.FORM_FIELDS;
const LIST_HEADER_FIELDS = API_CALLS.REFERRALS.LIST_HEADER_FIELDS;

const PREVIEW = API_CALLS.REFERRALS.PREVIEW;

const API_CALLS_FULL = {
  QUERY,
  QUERY_SINGLE,
  QUERY_COUNT,
  MUTATION_EDIT,
  MUTATION_ADD,
  FORM_FIELDS,
  QUERY_GET_USERS,
  PREVIEW
};






const ValidateObject = (newObject, onSuccess, onFail)=>{
  if(newObject._id && !newObject.id) newObject.id = newObject._id;      
  console.log("newObject");
  console.log(newObject,"\n\n");
        
  Object.keys(newObject).map((key, index)=>{
    if(!newObject[key]) delete newObject[key];
  })  
  onSuccess(newObject);
  //onFail();      
};





const PAGES = () => [
  {
    "id": "REFERRALS01",
    "Name":"Active",
    "PageName": "Active",
    "BasePage": "referrals",
    "Path": "upcoming",
    "TITLE": "Active Referrals",
    "DATA_FIELD": "referrals",
    "GlobalStateVar": ["refCountUpcomming"],
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "ACTIVE",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0,
      "include": [
        {
          name: "user"
        },
        {
          name: "coupon"
        }
      ]
    },
    "NEWBUTTON": {
      NAME: "REFERRALS",
      TITLE: "Referral",
      FIELD: "referral"
    },
    "EDITBUTTON": {
      NAME: "REFERRALS",
      TITLE: "Referral",
      FIELD: "referral"
    },
    "DELETEBUTTON": {
      NAME: "REFERRALS"
    },
    "CLONEBUTTON": {
      NAME: "REFERRALS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("referrals/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Referral",
            "TITLE": "Referral", //TITLE OF SLIDE OUT
            "APINAME": "REFERRALS",
            "NAME": "Referral",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  },
  {
    "id": "REFERRALS02",
    "Name":"Pending",
    "PageName": "Pending",
    "BasePage": "referrals",
    "Path": "pending",
    "TITLE": "Pending Referrals",
    "DATA_FIELD": "referrals",
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "PENDING",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0,
      "include": [
        {
          name: "user"
        },
        {
          name: "coupon"
        }
      ]
    },
    "NEWBUTTON": {
      NAME: "REFERRALS",
      TITLE: "Referral",
      FIELD: "referral"
    },
    "EDITBUTTON": {
      NAME: "REFERRALS",
      TITLE: "Referral",
      FIELD: "referral"
    },
    "DELETEBUTTON": {
      NAME: "REFERRALS"
    },
    "CLONEBUTTON": {
      NAME: "REFERRALS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("referrals/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Referral",
            "TITLE": "Referral", //TITLE OF SLIDE OUT
            "APINAME": "REFERRALS",
            "NAME": "Referral",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  },
  {
    "id": "REFERRALS03",
    "Name":"History",
    "PageName": "History",
    "BasePage": "referrals",
    "Path": "history",
    "TITLE": "Referral History",
    "DATA_FIELD": "referrals",
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "NOTINACTIVE",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0,
      "include": [
        {
          name: "user"
        },
        {
          name: "coupon"
        }
      ]
    },
    "NEWBUTTON": {
      NAME: "REFERRALS",
      TITLE: "Referral",
      FIELD: "referral"
    },
    "EDITBUTTON": {
      NAME: "REFERRALS",
      TITLE: "Referral",
      FIELD: "referral"
    },
    "DELETEBUTTON": {
      NAME: "REFERRALS"
    },
    "CLONEBUTTON": {
      NAME: "REFERRALS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("referrals/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Referral",
            "TITLE": "Referral", //TITLE OF SLIDE OUT
            "APINAME": "REFERRALS",
            "NAME": "Referral",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  }
];





const Index = (props) => {
  //var {data} = props;
  var today = new Date();
  return (
     <TemplatePage
      ID={"AdminReferrals"}
      REPORTS={
        [
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfDay().getTime()}`
              }]
            },
            NAME: "refCount",
            TITLE: "New Referrals Today"
          },
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfWeek().getTime()}`
              }]
            },
            NAME: "refCount",
            TITLE: "Referrals this Week"
          },
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfMonth().getTime()}`
              }]
            },
            NAME: "refCount",
            TITLE: "Referrals this Month"
          },
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfYear().getTime()}`
              }]
            },
            NAME: "refCount",
            TITLE: "Referrals this Year"
          }
        ]
      }
      REDIRECT={{
        "path": "/",
        "to": "upcoming"
      }}
      PAGES={PAGES()}
      ValidateObject={ValidateObject}
    />
  );
}





export default Index;

export {PAGES};   

      
